<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            type: {
                type: String,
                default: 'select'
            },
            name: {
                type: String,
                default: ''
            },
            value: {},
            label: String,
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            multipleMini: {
                type: Boolean,
                default: false,
            },
            sort: {
                type: Boolean,
                default: false,
            },
            noValue0: {
                type: Boolean,
                default: false,
            },
            filters: {
                type: Object,
            }

        },
        data() {
            return {
                v: this.value,
            }
        },
        methods: {
            get_list() {
                this.$store.dispatch('dictionary/' + this.name + '/get_list');
            },
            change(v) {
                this.v = v;
                this.$emit('change', v);
                this.$emit('input', v);
            },
        },
        computed: {
            load() {
                return this.$store.state.dictionary[this.name].load
            },
            list() {
                let list = this.$store.state.dictionary[this.name] ? this.$store.state.dictionary[this.name].list.concat() : [];
                if (this.sort) list = list.sort((a, b) => {
                    return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
                });
                if (this.noValue0) list = list.filter(a => {
                    return a.value !== 0;
                });
                return list;
            },
            txt_multiple() {
                if (!Array.isArray(this.v)) return 'Выбрать';
                if (!this.v.length) return 'Выбрать';
                return 'Выбрано: ' + this.v.length;
            },
        },
        watch: {
            value(v) {
                this.v = v;
            },
            v(v) {
//                this.$emit('input', v);
            },
            name(v) {
                this.get_list();
            },
        },
        mounted() {
            this.get_list();
        },
        components: {},
    }
</script>
<template>
    <div class="input-dictionary" :class="{'mini--multiple': multiple&&multipleMini}">
        <div class="el-input-group el-input--mini" :class="{'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <template v-if="type==='select'">
                <el-select :value="value" @change="change" :disabled="disabled" :clearable="clearable" :collapse-tags="true" :multiple="multiple" filterable placeholder="">
                    <el-option v-for="(item, index) in list" :value="item.value" :key="index" :label="item.label"></el-option>
                </el-select>
                <i v-if="multiple&&multipleMini&&clearable&&v&&v.length" @click="change([])" class="el-select__caret el-input__icon el-icon-circle-close is-show-close"></i>
            </template>
        </div>
        <div class="input__load" v-show="load">
            <i class="el-icon-loading"></i> Загрузка...
        </div>
    </div>
</template>
<style lang="scss">
    .input-dictionary {
        .el-select .el-tag {
            max-width: 138px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>
